import { render, staticRenderFns } from "./SubEquipPanel.vue?vue&type=template&id=3bc61045"
import script from "./SubEquipPanel.vue?vue&type=script&lang=js"
export * from "./SubEquipPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports